import { Practice } from "@/components/Practice";
export function MCQPractice() {
  return <Practice endpoint="/api/general_knowledge/random" sessionType="mcq" title="MCQ Practice" />;
}